/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

function isIE() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
        return true;
    else                 // If another browser, return 0
        return false;

    return false;
}

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

          if(isIE() || navigator.userAgent.match(/Windows Phone/i) || (/Edge\/12./i.test(navigator.userAgent)) || (/Edge\/13./i.test(navigator.userAgent)) || (/Edge\/14./i.test(navigator.userAgent))){

              jQuery('body').addClass('IEbrowser');

          }


     ;


          $(".navbar-menu .navbar-toggler").click(function(){
              $(".navbar-menu .navbar-collapse").addClass("menu--open");
          });

          $(".navbar-menu .close").click(function(){
              $(".navbar-menu .navbar-collapse").removeClass("menu--open");
          });

          $(document).ready(function(){
              $("#hamburger-menu").click(function(){
                  $("body").toggleClass('mobile-nav-open');
                  $("#hamburger-menu").toggleClass('active');
              });
          });

          $(function() {
              var header = $(".header-top, .hamburger-menu");
              $(window).scroll(function() {
                  var scroll = $(window).scrollTop();

                  if (scroll >= 1) {
                      header.addClass("header-alt");
                  } else {
                      header.removeClass("header-alt");
                  }
              });
          });

          (function($){
              $('.owl-carousel-home').owlCarousel({
                  autoplaySpeed: 1000,
                  autoplay: true,
                  dots: false,
                  nav: true,
                  loop:true,
                  items:1

              });

              $('.owl-carousel-solutions').owlCarousel({
                  items:4,
                  loop:true,
                  nav: true,
                  navText: ["<span class='flaticon-back'></span>","<span class='flaticon-back'></span>"],
                   responsive:{
                          0:{
                              items:1,
                              nav: false,
                              dots: true
                          },
                          481:{
                              items:2,
                              dots: false
                          },
                          992:{
                              items:4,
                              dots: false
                          }
                      }
              });

              $('.owl-carousel-brands').owlCarousel({
                  items:4,
                  loop:true,
                  nav: false,
                  margin: 12,
                  autoplay: true,
                  dots: true,
                  navText: ["<span class='flaticon-back'></span>","<span class='flaticon-back'></span>"],
                   responsive:{
                          400:{
                              items:1
                          },
                          600:{
                              items:2
                          },
                          800:{
                              items:3
                          },
                          992:{
                              items:5
                          }
                      }
              });

              $('.owl-carousel-difference').owlCarousel({
                  items:3,
                  loop:true,
                  nav: true,
                  navText: ["<span class='flaticon-back'></span>","<span class='flaticon-back'></span>"],
                  responsive:{
                          0:{
                              items:1,
                              nav: false,
                              dots: true
                          },

                          481:{
                              items:2,
                              dots: false
                          },
                          992:{
                              items:3,
                              dots: false
                          }
                      }
                      
              });

              $('.owl-carousel-testimonials').owlCarousel({
                  animateOut: 'fadeOut',
                  autoplaySpeed: 1000,
                  autoplay: true,
                  dots: false,
                  nav: true,
                  navText: ["<span class='flaticon-back'></span>","<span class='flaticon-back'></span>"],
                  loop:true,
                  items:1
              });

              $('.nav-features a').on('click', function (e) {
                  $(".nav-features a").removeClass("active").attr("aria-selected","false");
                  $(this).tab('show')
              });


              $(document).on('click', 'a[href^="#"]', function (event) {
                  event.preventDefault();

                  $('html, body').animate({
                      scrollTop: $($.attr(this, 'href')).offset().top
                  }, 800);
              });


          })(jQuery);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

          $(document).ready(function () {
              var elem = $(".section-intro .description p").contents().filter(function () { return this.nodeType == 3 }).first(),
                  text = elem.text().trim(),
                  first = text.slice(0, 1);

              if (!elem.length)
                  return;

              elem[0].nodeValue = text.slice(first.length);
              elem.before('<span class="first-letter">' + first + '</span>');
          });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
